import BaseErrorBlock from 'registration/js/base/error_block';

import template from 'registration/templates/simple/error_block.html';

const ErrorBlock = BaseErrorBlock.extend({
    template
});

export default ErrorBlock;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/simple/error_block.js